<script lang="ts">
  import { onMount } from "svelte"
  import Modal from "$app/components/Modal.svelte"
  import Picker from "emoji-picker-element/picker"
  import { Smile } from "lucide-svelte"

  let { id, onemoji }: { id: string; onemoji: (data: any) => void } = $props()

  let openModal = $state(false)

  let picker

  onMount(() => {
    const trigger = document.querySelector(`#emoji-trigger-${id}`)
    if (!(trigger instanceof HTMLElement))
      throw new Error("Could not find emoji trigger")
  })

  $effect(() => {
    if (openModal) {
      const triggerOut = document.querySelector(`#emoji-outer-${id}`)
      if (!(triggerOut instanceof HTMLElement))
        throw new Error("Could not find emoji trigger out")

      picker = new Picker()
      picker.addEventListener("emoji-click", (event) => {
        onemoji(event.detail)
      })

      triggerOut.appendChild(picker)
    }
  })
</script>

<button
  type="button"
  id={`emoji-trigger-${id}`}
  class="relative -m-2 inline-flex h-10 w-10 items-center justify-center rounded-full text-gray-400 hover:text-gray-500"
  aria-haspopup="listbox"
  aria-expanded="true"
  aria-labelledby="listbox-label"
  onclick={() => (openModal = !openModal)}
>
  <Smile class="size-5" />
  <span class="sr-only">Add your mood</span>
</button>

<Modal
  open={openModal}
  hasBackdrop={false}
  closeButton={true}
  class="border border-gray-200"
  closeOnOuterClick={true}
  onclose={() => {
    openModal = false
  }}
>
  <div id={`emoji-outer-${id}`} class="w-full mt-4"></div>
</Modal>
